<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center reset-outer-container"
  >
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 p-0">
      <div class="d-flex justify-content-center">
        <div class="mt-3">
          <img
            src="/favicon/c3-logo.png"
            class="rounded"
            alt="Community Care Connection"
          />
        </div>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-4 my-5 p-0">
      <div class="card shadow-card p-5 login-box-container">
        <h1 class="display-4 text-center mb-3 mt-4">Reset Password</h1>
        <p class="text-muted text-center mb-5">Community Care Connection</p>
        <form
          name="ResetPasswordForm"
          autocomplete="off"
          validate
          @submit.prevent="resetPassword"
        >
          <input-control
            v-model="password"
            id="password"
            control="password"
            required
          >
            Password
          </input-control>
          <input-control
            v-model="password_confirmation"
            id="password_confirmation"
            control="password"
            required
          >
            Confirm Password
          </input-control>
          <save
            :saving="auth.resettingPassword"
            classes="btn btn-lg btn-block btn-primary mb-3"
          >
            Reset Password
          </save>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "ResetPasswordForm",
  computed: {
    ...mapState(["auth"]),
  },
  data() {
    return {
      password: null,
      password_confirmation: null,
    };
  },
  methods: {
    ...mapActions({
      sendResetPassword: "auth/resetPassword",
    }),
    resetPassword() {
      if (this.password != this.password_confirmation) {
        return Swal.fire({
          title: "Validation Failed",
          text: "The password confirmation does not match.",
          type: "error",
        });
      }
      this.sendResetPassword({
        token: this.$route.params.token,
        email: this.$route.query.email,
        password: this.password,
        password_confirmation: this.password_confirmation,
      }).then(({ success, err }) => {
        if (success) {
          Swal.fire({
            title: "Reset Completed",
            text: "Password Successfully Reset",
            type: "success",
          });
          this.$router.push({ name: "login" });
        } else {
          Swal.fire({
            title: "Reset Password Failed",
            text: ((err.data || {}).error || err.error || {}).message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@media (max-width: 1024px) {
  .reset-outer-container {
    margin-top: -84px;
  }
}
</style>
